import React from 'react'
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { Box, Button, Typography, FormControlLabel, Checkbox } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export default function SignUpForm() {
    const [district, setDistrict] = React.useState('');
    const fieldStyles = { paddingBottom: "1rem" }

    const handleChange = (event: SelectChangeEvent) => {
      setDistrict(event.target.value);
    };

    return (
        <Box>
        <TextField required fullWidth id="name" label="Name" variant="outlined" sx={ fieldStyles } />
        <TextField required fullWidth id="role" label="Role" variant="outlined" sx={ fieldStyles } />
        <FormControl required fullWidth sx={ fieldStyles } >
            <InputLabel id="district-select-label">District</InputLabel>
            <Select
            labelId="district-select-label"
            id="district"
            value={district}
            label="District"
            onChange={handleChange}
            >
                <MenuItem value={10}>Your district</MenuItem>
            </Select>
        </FormControl>
        <TextField required fullWidth id="email" label="Email" variant="outlined" sx={ fieldStyles } />
        <FormControlLabel
            control={<Checkbox value="access" color="primary" />}
            label="I want early-access."
        />
        <FormControlLabel
            control={<Checkbox value="access" color="primary" />}
            label="I want a demo."
        />
        <Button
        fullWidth
        variant="contained"
        disableElevation
        color="secondary"
        sx={{ marginTop: "1.65rem", color: "white" }}>
            <Typography variant="h6">Submit</Typography>
        </Button>
    </Box>
    )
}